import { AnalyticsResponse, GetAnalyticsRequest, User } from '../../graphql/API';
import { venueGetAnalytics } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueGetAnalyticsApi = async (filter: GetAnalyticsRequest): Promise<AnalyticsResponse> => {
  const result = await executeGql<User>(venueGetAnalytics, { filter });
  return processGqlResult<AnalyticsResponse>('venueGetAnalytics', result);
};
